// import React from 'react'
import useSWR from 'swr'

export default function useBranch( ) {
  const { data: branches, error } = useSWR( 'merchants/branches')
  return {
    branches: branches?.data,
    isLoading: false,
    isError: error
  }
}